import { TanStackDevtools } from "@tanstack/react-devtools"
import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools"
import { useRouter } from "@tanstack/react-router"
import { TanStackRouterDevtoolsPanel } from "@tanstack/react-router-devtools"
import { DEVTOOLS_ENABLED } from "@/shared/config/env"
import { LocalStoragePanel } from "./local-storage-panel"

if (import.meta.env.MODE !== "production" || DEVTOOLS_ENABLED) {
	try {
		const key = "tanstack_devtools_state"
		const state = JSON.parse(localStorage.getItem(key) ?? "{}")
		state.height = Math.round(window.innerHeight * 0.7)
		localStorage.setItem(key, JSON.stringify(state))
	} catch {}
}

export function Devtools() {
	const router = useRouter()

	return (
		<TanStackDevtools
			config={{
				defaultOpen: false,
				position: "top-right",
				panelLocation: "bottom",
			}}
			eventBusConfig={{
				debug: false,
			}}
			plugins={[
				{
					name: "TanStack Query",
					render: <ReactQueryDevtoolsPanel />,
				},
				{
					name: "TanStack Router",
					render: <TanStackRouterDevtoolsPanel router={router} />,
				},
				{
					name: "Local Storage",
					render: <LocalStoragePanel />,
				},
			]}
		/>
	)
}
